function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 4588"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 153577",
    style: {
      fill: "none"
    },
    d: "M0 0h18v18H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.837-849.364.8-.8-2.864-2.864v-3.561h-1.137v4.022zm-2.632 3.771a7.017 7.017 0 0 1-2.81-.567 7.274 7.274 0 0 1-2.288-1.539 7.276 7.276 0 0 1-1.54-2.287A7.011 7.011 0 0 1 100-852.8a7.018 7.018 0 0 1 .567-2.81 7.277 7.277 0 0 1 1.539-2.288 7.277 7.277 0 0 1 2.287-1.54A7.011 7.011 0 0 1 107.2-860a7.018 7.018 0 0 1 2.81.567 7.279 7.279 0 0 1 2.288 1.539 7.275 7.275 0 0 1 1.54 2.287 7.011 7.011 0 0 1 .567 2.809 7.018 7.018 0 0 1-.567 2.81 7.277 7.277 0 0 1-1.538 2.288 7.275 7.275 0 0 1-2.287 1.54 7.011 7.011 0 0 1-2.813.567zm-.005-7.207zm0 6.066a5.848 5.848 0 0 0 4.3-1.766 5.848 5.848 0 0 0 1.772-4.294 5.848 5.848 0 0 0-1.772-4.294 5.848 5.848 0 0 0-4.294-1.772 5.848 5.848 0 0 0-4.294 1.772 5.848 5.848 0 0 0-1.772 4.294 5.848 5.848 0 0 0 1.772 4.294 5.848 5.848 0 0 0 4.288 1.769z",
    transform: "translate(-98.204 861.796)",
    style: {
      fill: "#121212"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeOutlined);
export default __webpack_public_path__ + "static/media/time_outlined.f92400acb49579f314591c8f8e8e4c4c.svg";
export { ForwardRef as ReactComponent };